import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ArrowDownIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ArrowDownIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/arrow/down">
            <path
                fill="none"
                id="Vector"
                d="M12 5V19M12 19L19 12M12 19L5 12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
